import React from "react";
import { toast } from "sonner";

/**
 * FeedTipBlock — patron-tip CTA. Bottom slot of the unified left-column
 * card (title → comments → tip), introduced in the Iter-57++++ layout
 * refactor (May 28, 2026).
 *
 * Originally lived inside FeedNowPlayingPanel; extracted so the parent
 * container can render its three sub-blocks (title, comments, tip)
 * with consistent dividers and no double-padding.
 *
 * No outer rounded chrome — the parent's container owns the visual
 * frame so all three blocks read as ONE connected card.
 */
const FeedTipBlock = ({
  activeVideos,
  currentVideoIndex,
  user,
  handleClosePlayer,
  navigate,
}) => {
  const v = activeVideos[currentVideoIndex];
  const producer = v?.username;
  if (!producer) return null;
  const isOwn = user?.username === producer;
  return (
    <div className="p-3" data-testid="feed-tip-block">
      <button
        onClick={() => {
          if (isOwn) {
            toast.info("That's your own channel — invite others to be your patrons!");
            return;
          }
          try {
            localStorage.setItem('globaleyes_referrer', JSON.stringify({
              username: producer,
              ts: Date.now(),
            }));
          } catch (_err) { /* ignore storage quota */ }
          handleClosePlayer();
          navigate('/pricing');
        }}
        data-testid="feed-patron-pitch"
        className={`w-full bg-gradient-to-br from-emerald-900/40 via-gray-800/50 to-amber-900/30 hover:from-emerald-800/60 hover:to-amber-800/40 border border-emerald-500/30 rounded-lg px-3 py-2.5 text-left transition-all group ${isOwn ? 'opacity-60' : ''}`}
      >
        <p className="text-white text-xs font-bold leading-tight whitespace-nowrap">
          TIP <span className="text-emerald-400">{producer}</span> 100 CREDITS TODAY
        </p>
        <p className="text-emerald-400 text-[11px] font-semibold mt-1 leading-tight group-hover:underline whitespace-nowrap">
          &amp; GET 100 CREDITS YOURSELF →
        </p>
      </button>
    </div>
  );
};

export default FeedTipBlock;
